<script setup lang="ts">
import type { EditorialModulesWrapperProps } from './EditorialModulesWrapper.props'

const props = defineProps<EditorialModulesWrapperProps>()

const localePath = useLocalePath()
const { user } = useUserSession()
const { isLogged } = useLogin()

const routeParams = useRoute().params
// @ts-ignore
const slug = routeParams.slug

const query = {
  locale: localePath(''),
  vse: useRoute().query.vse as string,
  contentId: useRoute().query.contentId,
  slug,
}
const { data: componentResponse, execute } = await useFetch<any>(
  `/api/cms/getByKey?locale=${query.locale}&id=${props.deliveryKey}&type=key&vse=${query?.vse ?? ''}`,
  {
    getCachedData: (k, nuxtApp) => nuxtApp.payload.data[k],
    immediate: false,
  }
)
if (!componentResponse.value) {
  await execute()
}
const editorials = computed(() =>
  connectComponents(
    componentResponse.value ? [componentResponse.value] : [],
    query.locale,
    query.vse ?? ''
  )
)

const eligibleTags = computed<string[]>(() => {
  const raw = componentResponse.value?.userTags
  if (!raw) return []
  return raw
    .split('|')
    .map((t: string) => t.trim())
    .filter(Boolean)
})

const clCustomerId = computed(
  () => user.value?.user_metadata?.commercelayer_id as string | undefined
)
const customerTags = ref<string[] | null>(null)

watch(
  [eligibleTags, () => isLogged, clCustomerId],
  async ([tags, logged, clId]) => {
    if (!tags?.length) {
      customerTags.value = null
      return
    }
    // Se non loggato o manca id CL, gating fallisce
    if (!logged || !clId) {
      customerTags.value = []
      return
    }
    try {
      customerTags.value = user?.value?.user_metadata?.customer_tags || []
      if (customerTags.value?.length === 0) {
        const id = user?.value?.user_metadata?.commercelayer_id as string
        customerTags.value = await getCustomerTags(id)
      }
    } catch (e) {
      console.error('Errore fetch customer tags:', e)
      customerTags.value = []
    }
  },
  { immediate: true }
)

const passesUserTags = computed<boolean>(() => {
  if (!eligibleTags.value.length) return true
  if (!customerTags.value) return false
  return eligibleTags.value.some(tag => customerTags.value?.includes(tag))
})

const showComponent = computed(() => {
  return Boolean(passesUserTags.value)
})
</script>

<template>
  <AmplienceDynamicContent v-if="showComponent" :components="editorials" />
</template>
